var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Pipe } from '@angular/core';
import { IndicatorLightType } from '../../../diagram/utils/indicator-light/indicator-light-type';
import { IndicatorLightHelper } from '../../../diagram/utils/indicator-light/indicator-light-helper';
import { ConfigureComponentBase } from '../../../../../shared/configure-component-base';
var StateConditionPipe = /** @class */ (function (_super) {
    __extends(StateConditionPipe, _super);
    function StateConditionPipe(injector) {
        return _super.call(this, injector) || this;
    }
    StateConditionPipe.prototype.transform = function (operator, useIndicatorLight, indicatorLightType, operand) {
        if (!useIndicatorLight) {
            return '';
        }
        // eslint-disable-next-line eqeqeq
        if (IndicatorLightType.Bit == indicatorLightType) {
            return IndicatorLightHelper.getBitIndicatorLightCondition(operator);
        }
        else if (!operator && operator !== 0) {
            return this.lc('Other');
        }
        else {
            return IndicatorLightHelper.getWordIndicatorLightCondition(operator) + operand;
        }
    };
    StateConditionPipe = __decorate([
        Pipe({
            name: 'stateCondition'
        })
    ], StateConditionPipe);
    return StateConditionPipe;
}(ConfigureComponentBase));
export { StateConditionPipe };
